import { formatPlayerRowLabel, formatTeamScore } from './HUD.js'

export function renderPostMatchDialog(gameOver, room, localPlayerId) {
  if (!gameOver) return ''
  const isDeathmatch = gameOver.mode === 'deathmatch'
  const isCtf = gameOver.mode === 'ctf'
  const standings = gameOver.standings ?? []
  const roster = room.roster ?? []
  const hostId = room.hostId
  const title = isDeathmatch
    ? 'And the winner is…'
    : isCtf
      ? (gameOver.winnerTeamId === 'yellow'
        ? 'Yellow Team Wins'
        : gameOver.winnerTeamId === 'cyan'
          ? 'Cyan Team Wins'
          : 'Time Up')
      : 'Game Over'
  return `
      <dialog class="post-match-modal">
        <div class="panel">
          <p class="eyebrow">ROUND COMPLETE</p>
          <h1>${title}</h1>
          ${isDeathmatch || isCtf ? `
            ${isCtf ? `<p>${formatTeamScore(gameOver.teamScores)}</p>` : ''}
            <ol class="standings-list">
              ${standings.map((row, index) => `
                <li class="standings-row">
                  <span>#${index + 1}</span>
                  <span>${formatPlayerRowLabel(row, { roster, hostId, localPlayerId })}</span>
                  <span>${row.score}</span>
                  <span>${row.kills}/${row.deaths}</span>
                </li>
              `).join('')}
            </ol>
          ` : `
            <p>Final score: ${gameOver.finalScore ?? 0}</p>
            <p>Waves cleared: ${gameOver.wavesCleared ?? 0}</p>
          `}
          <button type="button" data-role="return-to-lobby">Return to lobby</button>
        </div>
      </dialog>
    `
}
